import React, { useEffect, useState } from 'react';
import {StepIndicator,StepConnector} from '../components/Stepper.jsx'
import Options from '../components/Options'
import SelectVehicle from '../components/SelectVehicle'
import Book from '../components/Book'
import PaymentSuccess from '../components/PaymentSuccess'
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
// import BookReview from '../components/BookReview.jsx'
import PaymentFailure from '../components/PaymentFailure.jsx'
import { setBookingId } from "../redux/data.js";
import { useNavigate } from "react-router-dom";

function Booking() {
  const { id } = useParams();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const bookingId = useSelector((state) => state.data.bookingId)
  const [currentStep, setCurrentStep] = useState(1)
  const stepsArray = ['select-vehicle', 'extra', 'book', 'confirm']
  // console.log('id',bookingId,id)
  // useEffect(() => {
  //   navigate("/booking/" + bookingId)
  //   setCurrentStep(stepsArray.indexOf(bookingId) + 1)
  //   if(bookingId==='success'||bookingId==='failed'){
  //     setCurrentStep(stepsArray.indexOf('confirm') + 1)
  //   }
  // }, [bookingId]) // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    if (bookingId !== 'success' && bookingId !== 'failed') {
      navigate("/booking/" + bookingId);
      setCurrentStep(stepsArray.indexOf(bookingId) + 1);
    } else {
      setCurrentStep(stepsArray.indexOf('confirm') + 1);
    }
  }, [bookingId]) // eslint-disable-line react-hooks/exhaustive-deps

  const updateStep = (index) => {
    dispatch(setBookingId(stepsArray[index-1]))
    setCurrentStep(index)
  }

  return (
    <div className='w-full md:p-10 p-0 flex mb-2'>
      <div className='w-full'>
        <div className={`step-indicator-row`}>
          {stepsArray?.map((_, index) => {
            const stepNumber = index + 1;
            const isNotLastStep = index < 4 - 1;
            return (
              <React.Fragment key={stepNumber}>
                <StepIndicator
                  step={stepNumber}
                  currentStep={currentStep}
                  onClickStep={(clicked) => {
                    updateStep(clicked);
                  }}
                />
                {isNotLastStep && (
                  <StepConnector isComplete={currentStep > stepNumber} />
                )}
              </React.Fragment>
            );
          })}
        </div>

        {id === 'select-vehicle' ?
          <div>
            <div className="font-bold text-2xl uppercase">Step 1: Select Dates and Vehicle</div>
            <SelectVehicle/>
          </div>
          : id === 'extra' ?
            <div>
              <div className="font-bold text-2xl uppercase">Step 2: Select Options</div>
              <Options />
            </div>
            : id === 'book' ?
              <div className='w-full'>
                <div className="font-bold text-2xl uppercase">Step 3: Book</div>
                <Book />
              </div>
              : id?.includes('success') ?
                <div>
                  <div className="font-bold text-2xl uppercase">Step 4: Confirm</div>
                  <PaymentSuccess id={id} />
                </div>
                : id === 'failed' ?
                  <div>
                    <PaymentFailure />
                  </div>
                  : <div>

                    <div className="font-bold text-2xl uppercase">Opps, something goes wrong!</div>
                  </div>

        }
      </div>

      { id === 'extra' ?
        <div>
          <div className="lg:block hidden border-2 border-gray-300 w-lg mt-4 shadow-lg rounded-md duration-300 hover:shadow-sm ml-10" >
            {/* <BookReview /> */}
          </div>
        </div>
        : null}

    </div>
  );
}

export default Booking;